import { forwardRef, type Ref, type SVGProps } from "react";
const IconExclamationCircleFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M25.9 6.1A14 14 0 1 0 30 16a13.94 13.94 0 0 0-4.1-9.9M16 7a2 2 0 0 1 2 2.19L17.2 17a1.22 1.22 0 0 1-2.4 0L14 9.19A1.4 1.4 0 0 1 14 9a2 2 0 0 1 2-2m2 15a2 2 0 0 1-4 0 2 2 0 0 1 2-2 2 2 0 0 1 2 2" /></svg>;
const ForwardRef = forwardRef(IconExclamationCircleFilledSVG);
ForwardRef.displayName = "IconExclamationCircleFilled";
export { ForwardRef as IconExclamationCircleFilled };